// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2vJ9p","errors":"Errors_errors__3vGyt"};